import { createAsyncActionTypes } from '@mews/framework';
import { prefix } from '../module';

export const PRICING_FETCH = prefix('PRICING_FETCH');
export const [PRICING_FETCH_STARTED, PRICING_FETCH_SUCCEEDED, PRICING_FETCH_FAILED] =
    createAsyncActionTypes(PRICING_FETCH);

export const AVAILABILITY_FETCH = prefix('AVAILABILITY_FETCH');
export const [AVAILABILITY_FETCH_STARTED, AVAILABILITY_FETCH_SUCCEEDED, AVAILABILITY_FETCH_FAILED] =
    createAsyncActionTypes(AVAILABILITY_FETCH);

export const AVAILABILITY_BLOCK_SELECTED = prefix('AVAILABILITY_BLOCK_SELECTED');

export const CREATE_RESERVATION_GROUP = prefix('CREATE_RESERVATION_GROUP');
export const [CREATE_RESERVATION_GROUP_STARTED, CREATE_RESERVATION_GROUP_SUCCEEDED, CREATE_RESERVATION_GROUP_FAILED] =
    createAsyncActionTypes(CREATE_RESERVATION_GROUP);

export const CUSTOM_PRICE_VALUE_CHANGED = prefix('CUSTOM_PRICE_VALUE_CHANGED');

export const CUSTOM_PRICE_FETCH = prefix('CUSTOM_PRICE_FETCH');
export const [CUSTOM_PRICE_FETCH_STARTED, CUSTOM_PRICE_FETCH_SUCCEEDED, CUSTOM_PRICE_FETCH_FAILED] =
    createAsyncActionTypes(CUSTOM_PRICE_FETCH);

export const STEP_CHANGED = prefix('STEP_CHANGED');

export const DATES_CHANGED = prefix('DATES_CHANGED');
export const TIMES_CHANGED = prefix('TIMES_CHANGED');
export const TIMES_RESET = prefix('TIMES_RESET');
export const RESOURCE_CATEGORY_TYPE_SELECTED = prefix('RESOURCE_CATEGORY_TYPE_SELECTED');

export const RESERVATION_PLACE_SELECTED = prefix('RESERVATION_PLACE_SELECTED');
export const SERVICE_SELECTED = prefix('SERVICE_SELECTED');
export const SERVICE_FETCHED = prefix('SERVICE_FETCHED');

export const SEARCH_RESULT_CHANGE_STARTED = prefix('SEARCH_RESULT_CHANGE_STARTED');
export const SEARCH_RESULT_CHANGE_CANCELLED = prefix('SEARCH_RESULT_CHANGE_CANCELLED');
export const SEARCH_RESULT_CHANGE_CONFIRMED = prefix('SEARCH_RESULT_CHANGE_CONFIRMED');

export const OPTION_VALUE_CHANGED = prefix('OPTION_VALUE_CHANGED');
export const OPTION_VALUE_TOUCHED = prefix('OPTION_VALUE_TOUCHED');
export const OPTIONS_VALIDATED = prefix('OPTIONS_VALIDATED');

export const ORDER_VALUE_CHANGED = prefix('ORDER_VALUE_CHANGED');
export const CATEGORY_OCCUPANCY_CHANGED = prefix('CATEGORY_OCCUPANCY_CHANGED');

export const RESERVATION_ADDED = prefix('RESERVATION_ADDED');
export const RESERVATION_COUNT_CHANGED = prefix('RESERVATION_COUNT_CHANGED');
export const RESERVATIONS_CLEARED = prefix('RESERVATIONS_CLEARED');
export const RESERVATION_CLEARED = prefix('RESERVATION_CLEARED');

export const BASKET_PRICE_FETCH = prefix('BASKET_PRICE_FETCH');
export const [BASKET_PRICE_FETCH_STARTED, BASKET_PRICE_FETCH_SUCCEEDED, BASKET_PRICE_FETCH_FAILED] =
    createAsyncActionTypes(BASKET_PRICE_FETCH);

export const BASKET_PRODUCT_COUNT_CHANGED = prefix('BASKET_PRODUCT_COUNT_CHANGED');

export const SERVICE_CHANGE_STARTED = prefix('SERVICE_CHANGE_STARTED');
export const SERVICE_CHANGE_CONFIRMED = prefix('SERVICE_CHANGE_CONFIRMED');
export const SERVICE_CHANGE_CANCELLED = prefix('SERVICE_CHANGE_CANCELLED');

export const RESERVATION_PLACE_CHANGE_STARTED = prefix('RESERVATION_PLACE_CHANGE_STARTED');
export const RESERVATION_PLACE_CHANGE_CONFIRMED = prefix('RESERVATION_PLACE_CHANGE_CONFIRMED');
export const RESERVATION_PLACE_CHANGE_CANCELLED = prefix('RESERVATION_PLACE_CHANGE_CANCELLED');

export const CONFIRMATION_SHOWN = prefix('CONFIRMATION_SHOWN');
export const CONFIRMATION_DISMISSED = prefix('CONFIRMATION_DISMISSED');
export const RESET_SCREEN = prefix('RESET_SCREEN');

export const DEFAULT_OCCUPANCIES_SET = prefix('DEFAULT_OCCUPANCIES_SET');
export const PRICING_CLEARED = prefix('PRICING_CLEARED');
export const SCREEN_SERVICE_CHANGED = prefix('SCREEN_SERVICE_CHANGED');

export const RATE_ID_SELECTED = prefix('RATE_ID_SELECTED');
export const DEFAULT_RATES_CLEARED = prefix('DEFAULT_RATES_CLEARED');
export const MOBILE_RATE_GROUP_ID_SELECTED = prefix('MOBILE_RATE_GROUP_ID_SELECTED');
export const SEARCH_RESULT_CHANGE_UPDATED = prefix('SEARCH_RESULT_CHANGE_UPDATED');

export const CATEGORY_AVAILABILITY_CHANGED = prefix('CATEGORY_AVAILABILITY_CHANGED');
export const CUSTOM_PRICE_CLEARED = prefix('CUSTOM_PRICE_CLEARED');
export const CUSTOM_PRICE_VALIDATED = prefix('CUSTOM_PRICE_VALIDATED');

export const TAX_ENVIRONMENT_SET = prefix('TAX_ENVIRONMENT_SET');

export const FILTERS_CHANGED = prefix('FILTERS_CHANGED');

export const SHOW_CHANGE_DATE_DIALOG = prefix('SHOW_CHANGE_DATE_DIALOG');
export const HIDE_CHANGE_DATE_DIALOG = prefix('HIDE_CHANGE_DATE_DIALOG');

export const SHOW_CHANGE_SERVICE_DIALOG = prefix('SHOW_CHANGE_SERVICE_DIALOG');
export const HIDE_CHANGE_SERVICE_DIALOG = prefix('HIDE_CHANGE_SERVICE_DIALOG');

export const SERVICE_CATEGORIES_FETCH = prefix('SERVICE_CATEGORIES_FETCH');
export const [SERVICE_CATEGORIES_FETCH_STARTED, SERVICE_CATEGORIES_FETCH_SUCCEEDED, SERVICE_CATEGORIES_FETCH_FAILED] =
    createAsyncActionTypes(SERVICE_CATEGORIES_FETCH);

export const SHOW_NRS_LOADER = prefix('SHOW_NRS_LOADER');
export const HIDE_NRS_LOADER = prefix('HIDE_NRS_LOADER');
